import React from 'react';

interface DebugInfoProps {
  debugInfo: {
    position:
      | number[]
      | {
          x: number;
          y: number;
          z: number;
        };
    keys: {
      forward: boolean;
      backward: boolean;
      left: boolean;
      right: boolean;
      jump: boolean;
      run: boolean;
      rasengan?: boolean;
      shuriken?: boolean;
    };
    rasengans?: number;
    shurikens?: number;
  };
}

export const DebugInfo: React.FC<DebugInfoProps> = ({ debugInfo }) => {
  // Check if position is an array and handle accordingly
  const position = Array.isArray(debugInfo.position)
    ? {
        x: debugInfo.position[0],
        y: debugInfo.position[1],
        z: debugInfo.position[2],
      }
    : debugInfo.position;

  return (
    <>
      {/* Controls info */}
      <div
        style={{
          position: 'absolute',
          bottom: 60,
          left: 20,
          backgroundColor: 'rgba(0,0,0,0.0)',
          color: 'white',
          padding: 10,
          borderRadius: 5,
          fontFamily: 'monospace',
          fontSize: 12,
        }}
      >
        <div>WASD / Arrows - Move</div>
        <div>Space - Jump</div>
        <div>Shift - Run</div>
        <div>R - Rasengan (2s cooldown)</div>
        <div>F - Shuriken (0.2s cooldown)</div>
      </div>
      {/* Debug info display */}
      <div
        style={{
          position: 'absolute',
          bottom: 4,
          left: 20,
          backgroundColor: 'rgba(0,0,0,0.0)',
          color: 'white',
          padding: 10,
          borderRadius: 5,
          fontFamily: 'monospace',
          fontSize: 12,
        }}
      >
        <div>
          Position: X: {position.x.toFixed(2)}, Y: {position.y.toFixed(2)}, Z:{' '}
          {position.z.toFixed(2)}
        </div>
        <div>
          Keys: F: {debugInfo.keys.forward ? '✓' : '×'}
          B: {debugInfo.keys.backward ? '✓' : '×'}
          L: {debugInfo.keys.left ? '✓' : '×'}
          R: {debugInfo.keys.right ? '✓' : '×'}
          J: {debugInfo.keys.jump ? '✓' : '×'}
          Run: {debugInfo.keys.run ? '✓' : '×'}
        </div>
        {(debugInfo.rasengans !== undefined ||
          debugInfo.shurikens !== undefined) && (
          <div>
            Active:
            {debugInfo.rasengans !== undefined &&
              ` Rasengans: ${debugInfo.rasengans}`}
            {debugInfo.shurikens !== undefined &&
              ` Shurikens: ${debugInfo.shurikens}`}
          </div>
        )}
      </div>
    </>
  );
};
